const typography = {
  SERIAL_NUMBER: "S.No",
  DATE_TIME: "Date/Time",
  TOTAL_CLICKS: "Total Clicks",
  ACTION: "Actions",
  DEVICE: "Device",
  SOURCE: "Source",
  COUNTRY: "Country",
};

export default typography;
